export const INSTAGRAM_URL = 'https://www.instagram.com/joahair.gabba';

export const FACEBOOK_URL = 'https://www.facebook.com/profile.php?id=61559585184440';

export const RESERVATION_URL = 'https://book.clientdiary.com/business/joahair/';

export const GOOGLE_MAP_URL = 'https://maps.app.goo.gl/xf3D2xjfTmbqVDNq8';

export const GOOGLE_MAP_EMBED_URL =
  'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d884.8574572704383!2d153.0353113839044!3d-27.487004835609593!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b915bdaea787c6d%3A0xc6504f3a087dc801!2sJOA%20HAIR%20(Korean%20Hair%20Salon)!5e0!3m2!1sko!2skr!4v1717078833767!5m2!1sko!2skr';
